import Vue from "vue";
import axios from "@/plugins/axios";

// Single source of truth for the negeri dropdowns on the Jadual Awalan pages:
// MySQL lookupnegeri (codes 01–16) via /JadualAwalan/getNegeriList. The list
// is fetched once per page load and shared by every view. DEFAULT_NEGERI is
// the offline fallback shown until the fetch resolves (and kept if it fails),
// mirroring the table's current values.
export const DEFAULT_NEGERI = [
  { id: "01", nama: "Johor" }, { id: "02", nama: "Kedah" }, { id: "03", nama: "Kelantan" },
  { id: "04", nama: "Melaka" }, { id: "05", nama: "Negeri Sembilan" }, { id: "06", nama: "Pahang" },
  { id: "07", nama: "Pulau Pinang" }, { id: "08", nama: "Perak" }, { id: "09", nama: "Perlis" },
  { id: "10", nama: "Selangor" }, { id: "11", nama: "Terengganu" }, { id: "12", nama: "Sabah" },
  { id: "13", nama: "Sarawak" }, { id: "14", nama: "W.P. Kuala Lumpur" }, { id: "15", nama: "W.P. Labuan" },
  { id: "16", nama: "W.P. Putrajaya" },
];

// Vue.observable so computeds that read negeriStore.list re-run when the
// fetched names replace the fallback — a plain module array would render the
// fallback and never update.
export const negeriStore = Vue.observable({ list: DEFAULT_NEGERI });

let fetchPromise = null;

// Idempotent: the first caller triggers the fetch, later callers share it.
export function loadNegeriList() {
  if (!fetchPromise) {
    fetchPromise = axios
      .get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getNegeriList`)
      .then(res => {
        const rows = res.data && res.data.data && res.data.data.negeriList;
        if (Array.isArray(rows) && rows.length) negeriStore.list = rows;
        return negeriStore.list;
      })
      .catch(() => {
        fetchPromise = null; // failed fetch isn't cached — next page retries
        return negeriStore.list;
      });
  }
  return fetchPromise;
}
